import { useThemeUI } from 'theme-ui'
import { Col, Row, Container, EVEntry } from '@uswitch/ev-core/react'
import { Palette } from '../../elements/palette'
import { Badge, Type } from '@uswitch/spark'
import { TruCheckCircle } from '@uswitch/spark-icons/tru'
import { Modal, ModalClose } from '@uswitch/spark.modal'
import { useState } from 'react'
import { useDataSelector, useEntity } from '@uswitch/ev-utils/lib/context/selectors'
import SocialSharing from '../social-sharing'
import WrappedTrustyleAuthor from '../author/trustyle-author'
import { getVariantPath } from '@uswitch/ev-utils/lib/get-variant-path'

export const articleIntroStylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'compounds',
    componentId: 'article-intro',
    variantName: variant,
    field,
  })

const ArticleIntro = ({ description, socialSharing = true, title }) => {
  const [showModal, setShowModal] = useState(false)
  const { theme = {} } = useThemeUI()

  const rootEntityFields = useDataSelector(['rootEntity', 'fields'])
  const { authors, editors, factChecked = false, publishDate, updatedDate } = rootEntityFields

  const authorEntity = useEntity(authors?.[0])
  const editorEntity = useEntity(editors?.[0])

  const contentCols = theme?.compounds['article-intro']?.contentCols || 12
  const contentSpan = theme?.compounds['article-intro']?.contentSpan || 12

  return (
    <Container cols={contentCols} span={contentSpan}>
      <Row cols={12}>
        <Col span={[12, 12, 8]} sx={{ marginBottom: 0 }}>
          <Palette
            as={Type.H1}
            sx={{ variant: articleIntroStylePath('heading') }}
            px={{
              color: palette => palette.headingColor || palette.textColor,
            }}
          >
            {title}
          </Palette>
        </Col>
      </Row>
      <Row cols={12}>
        <Col span={[12, 12, 8]}>
          <WrappedTrustyleAuthor
            author={authorEntity}
            editor={editorEntity}
            publishDate={updatedDate || publishDate}
            showWrittenBy
          />
          <If condition={factChecked}>
            <Badge
              variant='success'
              leftIcon={<TruCheckCircle />}
              onClick={() => setShowModal(true)}
              sx={{ mb: 'lg', mt: 'xs' }}
            >
              Fact Checked
            </Badge>

            <If condition={showModal}>
              <Modal closeButton={<ModalClose onClick={() => setShowModal(false)} />}>
                <EVEntry {...factChecked} />
              </Modal>
            </If>
          </If>
          <Palette
            as={Type.Body1}
            sx={{ variant: articleIntroStylePath('description') }}
            px={{ color: 'textColor' }}
          >
            {description}
          </Palette>
        </Col>

        <If condition={socialSharing}>
          <Col span={[12, 12, 4]}>
            <div sx={{ variant: articleIntroStylePath('social-divider') }}>
              <SocialSharing wrap={false} />
            </div>
          </Col>
        </If>
      </Row>
    </Container>
  )
}

export default ArticleIntro
